<template>
	<div class="pb-2">
		<div class="head-title px-6">
			<ClaimButton 
				:control="control" 
				:itemNumber="itemNumber"
				:itemNumberSubmit="itemNumberSubmit"
				:itemNumberDelete="itemNumberDelete"
				:itemNumberRecover="itemNumberRecover"
				:privileges="privileges"
				:submitLoading="submit_loading"
				:printDialog="print_dialog"
				:visibleRecover="visible_recover"
				@del-claims="visible_delete = true" 
				@submit="onSubmit()" 
				@print="onPrint()"
				@recover="onRecoverDialog()"
				@create-claim="$emit('create-claim')" />
			<ClaimView 
				:typeSelected="type"
				:viewSelected="view"
				:statuses="claim_statuses"
				:customise_view="customise_view"
				@status="onChangeStatus($event)"
				@column="onChangeColumn($event)"/>
		</div>
		<v-alert class="mx-6 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<ProgressGetDataLinear v-if="loading" class="px-5"/>
		<ClaimTable 
			class="ma-6" 
			v-if="!loading" 
			:color="color"
			:currencies="currencies"
			:header="header_local"
			:items="filterResults"
			:titleText="`Claims`"
			@button-visible="onButtonVisible($event)"
			@row-click="$emit('row-click', $event)"
		/>
		<DeleteConfirmDialog
			v-if="visible_delete"
			:visible="visible_delete"
			:title="`You are about to delete claim(s)`"
			:content="`This action cannot be undone. Are you sure?`"
			:okText="`Delete`"
			@cancel="visible_delete = false"
			@ok="onDelClaims()"
		/>
		<RecoverDialog
			v-if="visible_recover"
			:visible="visible_recover"
			:textColor="color"
			:titleText="'Recover deleted claim?'"
			:userName="user_name"
			@cancel="visible_recover = false"
			@ok="onRecover($event)"
		/>
		<PrintClaims 
			v-if="print_visible" 
			id="print"
			style="display: none"
			:printClaims="print_claims"
			:isGST="false"/>
		<DialogProgress 
			:visible="print_dialog" 
			:color="color"
		/>
	</div>
</template>
<script>
import ClaimButton from "@/views/expenses/claims/claim_button";
import ClaimTable from "@/views/expenses/claims/claim_table";
import ClaimView from "@/views/expenses/claims/claim_view.vue";

import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import DialogProgress from "@/components/dialogs/progress_dialog.vue";
import RecoverDialog from "@/views/expenses/commond/recover_dialog.vue";
import DeleteConfirmDialog from "@/views/expenses/commond/delete_confirm_dialog.vue";

import PrintClaims from '@/components/expenses/print_claims';
import Claim from "@/models/claim.js"
import config from "@/config.js";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const SCALE = 1.2;
const MAX_WIDTH = 600;
const PAGE_INIT = 0;

const CLAIM_STATUSES = config.claim_statuses;
const SUBMITTED_SWITCH = {
	key: 'Submitted',
	value: 'Submitted'
};
const ACCEPTED_SWITCH = {
	key: 'Accepted',
	value: 'Approved'
};

const CLAIM_STATUS = [
	{ text: 'Draft', value: 0 },
	{ text: 'Submitted', value: 1 },
	{ text: 'Approved', value: 2 },
	{ text: 'Rejected', value: 3 },
	{ text: 'Posted', value: 4 },
	{ text: 'Partially Paid', value: 7 },
	{ text: 'Paid', value: 6 },
	{ text: 'Deleted', value: 5 },
];

export default {
	name:'ListClaims',
	components: {
		ClaimButton,
		ClaimTable,
		ClaimView,
		ProgressGetDataLinear,
		PrintClaims,
		DialogProgress,
		RecoverDialog,
		DeleteConfirmDialog
	},
	props: {
		color: {
			type: String,
			default: ""
		},
		currencies: {
			type: Array,
			default: () => {},
		},
	},
	data() {
		this.remark_date_flag = config.remark_date_flag;
		return {
			user_id: 0,
			loading: false,
			error_msg: '',
			control: false,
			header_local: config.claims_head,
			claim_statuses: CLAIM_STATUS,
			customise_view: config.claims_head.filter(head => {return head.showable && head.value !== 'select'}),

			type: CLAIM_STATUS.filter(c => { return c.value !== CLAIM_STATUSES.deleted.value }),
			type_save: CLAIM_STATUS.filter(c => { return c.value !== CLAIM_STATUSES.deleted.value }),
			view: [],
			view_save: [],

			itemNumber: 0,
			itemNumberSubmit: 0,
			itemNumberDelete: 0,
			itemNumberRecover: 0,
			claims: [],
			claims_original: [],

			print_claims: [],
			image_arr: [],
			print_dialog: false,
			print_visible: false,
			recover_claims: [],
			visible_recover: false,
			visible_delete: false,
			submit_loading: false
		}
	},
	watch: {
		user_abid() {
			if (this.user_abid !== 0) {
				this.load_claims();
			}
		},
	},
	computed: {
		privileges() {
			return this.$store.state.privileges.filter(p => { return p.startsWith('S')});
		},
		isCreatAndEditPrivilege() {
			/** Create and edit expense claims */
			return this.$store.state.privileges.includes('Sec');
		},
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
		user_name() {
			let name = '';
			const user = this.$store.state.user;
			if (user) {
				name = user.addressbook.display_name;
			}
			return name;
		},
		filterResults() {
			const filterRes = [];
			this.claims.forEach(claim => {
				const obj = {};	
				const header_tmp = config.claims_head;

				header_tmp.forEach(item => {
					if (item.showable) {
						obj[item.value] = claim[item.value];
					}
				});

				obj['id']	= claim.id;
				obj['select'] = claim.select ? claim.select : false;

				filterRes.push(obj);
			});
			return filterRes;
		},
	},
	async created() {
		if (!this.$store.state.user) {
			await this.getUserId();
		} else {
			this.user_id = this.$store.state.user.id;
		}

		if (this.$store.state.privileges && this.$store.state.privileges.length === 0) {
			this.initPrivileges();
		} 

		await this.getSettings();
		await this.load_claims();
	},
	methods: {
		async getUserId() {
			const url = '/api/user/me';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.user_id = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		initPrivileges() {
			this.$store.dispatch('update_privileges');
		},
		async getSettings() {
			this.loading = true;
			const usid = this.user_id;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);
								const type_tmp = windata.type;
								const view_tmp = windata.options;

								this.type = CLAIM_STATUS.filter(c => { return type_tmp.includes(c.value) });
								this.view = config.claims_head.filter(head => {return head.showable && view_tmp.includes(head.value) });

								this.type_save = this.type;
								this.view_save = this.view;
							}
						} else {
							this.view = config.claims_head.filter(head => {return head.showable && head.value !== 'select'});
							this.view_save = config.claims_head.filter(head => {return head.showable && head.value !== 'select'});
						}

						this.initTableHead();

						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.user_id;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		initTableHead() {
			const head_seleced = config.claims_head.filter(head => { return head.showable && head.value === 'select'});
			
			const view = this.view.map(v => { return v.value });
			const head_other = config.claims_head.filter(head => { return view.includes(head.value) });

			this.header_local = [...head_seleced, ...head_other];
		},
		load_claims() {
			const user_abid = this.user_abid;
			if (user_abid != 0) {
				const statuses = this.type.map(c => { return c.value});
				if (statuses.includes(CLAIM_STATUSES.paid.value)) {
					statuses.push(CLAIM_STATUSES.posted.value);
				}
				if (statuses.includes(CLAIM_STATUSES.partiallyPaid.value)) {
					statuses.push(CLAIM_STATUSES.posted.value);
				}
				if (statuses.length === 0) {
					this.claims_original = [];
					this.claims = [];
				}

				if (statuses.length > 0) {
					this.loading = true;
					const claim = new Claim();
					claim.list(user_abid, `${statuses}`, "")
						.then(data => {
							data.forEach(d => {
								if (d.status === SUBMITTED_SWITCH.key) {
									d.status = SUBMITTED_SWITCH.value;
								}
								if (d.status === ACCEPTED_SWITCH.key) {
									d.status = ACCEPTED_SWITCH.value;
								}
								if (d.status === CLAIM_STATUSES.posted.text && d.has_payment) {
									d.status = CLAIM_STATUSES.partiallyPaid.text;
								}
							});

							const status_text_arr = this.type.map(c => { return c.text});
							if (!status_text_arr.includes(CLAIM_STATUSES.posted.text)) {
								data = data.filter(d => { return d.status !== CLAIM_STATUSES.posted.text });
							}
							if (!status_text_arr.includes(CLAIM_STATUSES.paid.text)) {
								data = data.filter(d => { return d.status !== CLAIM_STATUSES.paid.text });
							}
							if (!status_text_arr.includes(CLAIM_STATUSES.partiallyPaid.text)) {
								data = data.filter(d => { return d.status !== CLAIM_STATUSES.partiallyPaid.text });
							}

							const others_arr = data.filter(d => {return d.status == CLAIM_STATUSES.pending.text || d.status == CLAIM_STATUSES.rejected.text });
							others_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date2 - date1;
							});
							others_arr.forEach(o => {
								if (o.status == CLAIM_STATUSES.rejected.text) {
									const remark_split_arr = o.remark ? o.remark.split(this.remark_date_flag) : [null, null];
									const remark = remark_split_arr[0];
									const remark_date = remark_split_arr[1];
									o['remark'] = remark ? remark : '';
									o['remark_date'] = remark_date ? remark_date : null;
								}
							});

							const draft_arr = data.filter(d => {return d.status === CLAIM_STATUSES.draft.text });
							draft_arr.sort((a, b) => {
								const date1 = Date.parse(a.date);
								const date2 = Date.parse(b.date);
								return date2 - date1;
							});

							const approve_arr = data.filter(d => {return d.status === CLAIM_STATUSES.approved.text });
							approve_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date2 - date1;
							});

							const posted_arr = data.filter(d => {return d.status === CLAIM_STATUSES.posted.text });
							posted_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date2 - date1;
							});

							const partially_arr = data.filter(d => {return d.status === CLAIM_STATUSES.partiallyPaid.text });
							partially_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date2 - date1;
							});

							const paid_arr = data.filter(d => {return d.status === CLAIM_STATUSES.paid.text });
							paid_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date2 - date1;
							});

							const deleted_arr = data.filter(d => {return d.status === CLAIM_STATUSES.deleted.text });
							deleted_arr.sort((a, b) => {
								const date1 = Date.parse(a.submitted_date);
								const date2 = Date.parse(b.submitted_date);
								return date2 - date1;
							});

							this.claims_original = [];
							this.claims_original.push(...draft_arr);
							this.claims_original.push(...others_arr);
							this.claims_original.push(...approve_arr);
							this.claims_original.push(...posted_arr);
							this.claims_original.push(...partially_arr);
							this.claims_original.push(...paid_arr);
							this.claims_original.push(...deleted_arr);

							this.claims = this.claims_original;

							this.loading = false;
							this.control = false;
							this.itemNumber = 0;
							this.itemNumberSubmit = 0;
							this.itemNumberDelete = 0;
						}, (msg) => {
							this.loading = false;
							this.error_msg = msg;
						});
				}
			}
		},
		onChangeStatus(status) {
			this.type = status;
			this.load_claims();

			this.type_save = status;
			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onChangeColumn(column) {
			const head_seleced = config.claims_head.filter(head => { return head.showable && head.value === 'select'});
			const head_other = config.claims_head.filter(head => { return column.includes(head.value) });
			this.header_local = [...head_seleced, ...head_other];

			this.view_save = config.claims_head.filter(head => {return head.showable && column.includes(head.value) });

			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onButtonVisible(claim_arr) {
			const arr_tmp = claim_arr.map(val => { return val.select});
			this.control = arr_tmp.some(val => {return val});

			const itemNumber_tmp = claim_arr.filter(val => { return val.select });
			this.itemNumber = itemNumber_tmp.length;

			const itemNumberSubmit_tmp = claim_arr.filter(val => { return val.select && val.status === CLAIM_STATUSES.draft.text && this.isCreatAndEditPrivilege });
			this.itemNumberSubmit = itemNumberSubmit_tmp.length;

			const itemNumberDelete_tmp = claim_arr.filter(val => {
				return val.select && val.status !== CLAIM_STATUSES.posted.text && val.status !== CLAIM_STATUSES.partiallyPaid.text && val.status !== CLAIM_STATUSES.approved.text && val.status !== CLAIM_STATUSES.paid.text && val.status !== CLAIM_STATUSES.deleted.text && this.isCreatAndEditPrivilege;
			});
			this.itemNumberDelete = itemNumberDelete_tmp.length;

			const itemNumberRecover_tmp = claim_arr.filter(val => {
				return val.select && val.status === CLAIM_STATUSES.deleted.text && val.status !== CLAIM_STATUSES.posted.text && val.status !== CLAIM_STATUSES.partiallyPaid.text && val.status !== CLAIM_STATUSES.paid.text && this.isCreatAndEditPrivilege;
			});
			this.itemNumberRecover = itemNumberRecover_tmp.length;
		},
		async onDelClaims() {
			const filter_arr = this.filterResults.filter(res => {
				return res.select 
					&& res.status !== CLAIM_STATUSES.posted.text 
					&& res.status !== CLAIM_STATUSES.approved.text
					&& res.status !== CLAIM_STATUSES.partiallyPaid.text
					&& res.status !== CLAIM_STATUSES.paid.text
					&& res.status !== CLAIM_STATUSES.deleted.text;
			});
			const filter_arr_ids = filter_arr.map(arr => { return arr.id });

			for (let index = 0; index < filter_arr_ids.length; index++) {
				const claim_record = new Claim();

				const id = filter_arr_ids[index];
				claim_record.id = id;

				await claim_record.delete().then(() => {
					this.claims = this.claims.filter(claim => { return claim.id !== id });	
					this.visible_delete = false;	
				}, (e) => {
					this.error_msg = e;
				});
			}

			this.control = this.filterResults.some(res => { return res.select });
		},
		async onSubmit() {
			if (this.submit_loading) {
				return;
			}
			
			const filter_arr = this.filterResults.filter(res => { 
				return res.select && res.status === CLAIM_STATUSES.draft.text
			});
			const filter_arr_ids = filter_arr.map(arr => { return arr.id });
			this.submit_loading = true;
			this.error_msg = '';

			for (let index = 0; index < filter_arr_ids.length; index++) {
				const id = filter_arr_ids[index];

				try {
					const claim_data = await this._getClaim(id);
					await this._submit(claim_data);
				} catch (e) {
					this.error_msg = e.message || e;
				}
			}

			this.submit_loading = false;
			this.load_claims();
		},
		async onPrint() {
			if (this.print_dialog) {
				return;
			}

			this.print_dialog = true;
			this.print_claims = [];

			const image_blob_arr = [];
			const selected_claims = this.filterResults.filter(f => { return f.select === true });

			for (let index = 0; index < selected_claims.length; index++) {
				const selected_claim = selected_claims[index];
				const url = "/api/expenses/claims/" + selected_claim.id;
				await axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then(val => {
						const { status, data, reason } = val.data;

						if (status == "OK") {
							data.details.forEach(d => {
								if (d.receipt.image_type.length !== 0) {
									const obj_tmp = {
										id: data.id,
										receipt: d.receipt 
									};
									image_blob_arr.push(obj_tmp);
								}
							});

							const obj = {
								id: selected_claim.id,
								number: selected_claim.number,
								desc: selected_claim.desc,
								submitted_date: selected_claim.submitted_date,
								value: selected_claim.value,
								currency: selected_claim.currency.symbol,
								approval_by: selected_claim.approval_by.display_name,
								employee: data.supplier.display_name,
								supplier: data.supplier.display_name,
								claim_date: selected_claim.date,
								details: data.details,
							};
							this.print_claims.push(obj);

						} else {
							this.error_msg = reason;
						}
					})
					.catch(e => {
						this.error_msg = e.message;
					});
			}

			this.getImageList(image_blob_arr);
		},
		onRecoverDialog() {
			if (this.visible_recover) {
				return;
			}

			const filter_arr = this.filterResults.filter(res => {
				return res.select 
					&& res.status === CLAIM_STATUSES.deleted.text 
					&& res.status !== CLAIM_STATUSES.posted.text
					&& res.status !== CLAIM_STATUSES.partiallyPaid.text
					&& res.status !== CLAIM_STATUSES.paid.text;
			});
			this.recover_claims = filter_arr;
			this.visible_recover = true;
		},
		async onRecover(reason) {
			const array = this.recover_claims;
			for (let index = 0; index < array.length; index++) {
				const element = array[index];
				await this._recover_claim(element.id, reason);
			}
		},
		async getImageList(image_blob_arr) {
			if (image_blob_arr.length === 0) {
				this.print_claims.forEach(print_claim => {
					print_claim['image_arr'] = [];
				});
				this.setPrintItem();
			}

			if (image_blob_arr.length !== 0) {
				for (let index = 0; index < image_blob_arr.length; index++) {
					const image_obj = image_blob_arr[index];
					const url = `/api/expenses/receipts/${image_obj.receipt.id}/image`;
					await axios
						.get(url, {
							headers: {
								"Authorization": "Bearer " + this.$store.state.token,
								"Accept": "application/json"
							},
							responseType: 'blob',
						})
						.then((val) => {
							const { status, data } = val;
							if (status === 200) {
								if (image_obj.receipt.image_type === 'application/pdf') {
									const reader = new FileReader();
									reader.readAsDataURL(data); 
									reader.onload = readerEvent =>  {
										const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
										loadingTask.promise.then(pdf => {
											const preview_url = [];
											let page_total = pdf.numPages;

											for (let index = 0; index < pdf.numPages; index++) {
												pdf.getPage(index + 1).then(page => {
													const scale = SCALE;
													const viewport = page.getViewport({scale: scale});

													const canvas = document.createElement('canvas');
													const context = canvas.getContext('2d');
													canvas.width = viewport.width;
													canvas.height = viewport.height;

													const renderContext = {
														canvasContext: context,
														viewport: viewport
													};

													const renderTask = page.render(renderContext);
													renderTask.promise.then(() => {
														canvas.toBlob(blob => {
															const preview_item_url = URL.createObjectURL(blob);
															preview_url.push(preview_item_url);
															page_total -= 1;

															if (page_total === PAGE_INIT) {
																const dimension = this.getDimension(viewport.width, viewport.height);
																const obj = {
																	id: image_obj.id,
																	width: dimension.width,
																	height: dimension.height,
																	image: preview_url
																};
																this.image_arr.push(obj);

																if (image_blob_arr.length === this.image_arr.length) {
																	this.print_claims.forEach(print_claim => {
																		print_claim['image_arr'] = this.image_arr;
																	});
																	this.setPrintItem();
																}
															}
														});									
													});
												});
											}
										});
									};
								} else {
									const my_image = new Image();
									const preview_item_url = URL.createObjectURL(data);
									my_image.src = preview_item_url;
									my_image.onload = () => {
										const dimension = this.getDimension(my_image.width, my_image.height);
										const obj = {
											id: image_obj.id,
											width: dimension.width,
											height: dimension.height,
											image: preview_item_url
										};
										this.image_arr.push(obj);

										if (image_blob_arr.length === this.image_arr.length) {
											this.print_claims.forEach(print_claim => {
												print_claim['image_arr'] = this.image_arr;
											});
											this.setPrintItem();
										}
									}

								}
							}
						})
						.catch((e) => {
							this.error_msg = e.message;
						});
				}
			}
		},
		getDimension(width, height) {
			let image_width = 0;
			let image_height = 0;

			if (this.$vuetify.breakpoint.smAndDown) {
				/* 48 = padding-left-24px + padding-right-24px */
				if (width > height) {
					image_width = this.$vuetify.breakpoint.width - 48;
					image_height = (this.$vuetify.breakpoint.width - 48) * height / width;
				} else {
					image_height = this.$vuetify.breakpoint.width - 48;
					image_width = (this.$vuetify.breakpoint.width - 48) * width / height;
				}
			} else {
				if (width > height) {
					image_width = MAX_WIDTH;
					image_height = MAX_WIDTH * height / width;
				} else {
					image_height = MAX_WIDTH;
					image_width = MAX_WIDTH * width / height;
				}
			}

			return { width: image_width, height: image_height };
		},
		setPrintItem() {
			this.print_dialog = false;
			this.print_visible = true;

			setTimeout(() => { 
				const printHtml = document.getElementById("print").innerHTML;
				const printFrame = document.createElement('iframe');
				printFrame.srcdoc = printHtml;
				document.body.appendChild(printFrame);

				printFrame.onload = () => {
					printFrame.contentWindow.print();
					
					const mql = printFrame.contentWindow.matchMedia('print');
					mql.onchange = (e) => {
						if (e.matches) {
							/* before print */
						} else {
							/* after print */
							document.body.removeChild(printFrame);
							this.print_visible = false;
							this.image_arr = [];
							this.load_claims();
						}
					}
				}
			},20);
		},
		async _getClaim(id) {
			const url = `/api/expenses/claims/${id}`;

			const response = await axios.get(url, {
				headers: {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"
				}
			});
			const { status, data, reason } = response.data;

			if (status !== "OK") {
				throw new Error(reason);
			}

			return data;
		},
		async _submit(claim) {
			const url = `/api/expenses/claims/${claim.id}`;

			const params = {
				supplier_id: claim.supplier.id,
				date: claim.date,
				desc: claim.description,
				currency_id: claim.currency.id,
				approval_by: claim.approval_by.id,
				status: CLAIM_STATUSES.pending.value,
				remark: '',
				period_id: claim.period.id,
				send_email: true
			};

			const details = [];
			for (let index = 0; index < claim.details.length; index++) {
				const detail = claim.details[index];

				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(detail.amount),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(detail.gross),
					tax_mode: detail.tax_mode,
					tax_perc: Number(detail.tax_perc),
					tax_amount: Number(detail.tax_amount),
					markup: Number(detail.markup),
					value_fc: Number(detail.value_fc),
				});
			}

			params['details'] = details;

			const response = await axios.put(url, params, {
				headers: {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"
				}
			});
			const { status, reason } = response.data;

			if (status !== "OK") {
				throw new Error(reason);
			}
		},
		async _recover_claim(id, reason) {
			const url = `/api/expenses/claims/${id}/reactivate?remark=${reason}`;

			await axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.recover_claims = this.recover_claims.filter(p => { return p.id !== id });

						if (this.recover_claims.length === 0) {
							this.visible_recover = false;
							this.load_claims();
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		},
		_setWinSetup() {
			const type_tmp = this.type_save.map(t => { return t.value });
			const view_tmp = this.view_save.map(t => { return t.value });

			const win_setup_obj = {
				type: type_tmp,
				options: view_tmp,
			};

			const win_setup_str = JSON.stringify(win_setup_obj);
			return win_setup_str;
		}
	}
}
</script>
<style lang="scss" scoped>
.head-title {
  height: 68px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
}
</style>
